import React from 'react';

import { IconProps } from '@shared/ui/Icon/model/types';

export const FileItemPlaceholder = ({ fill = '#D7D7D7', height = 26, width = 26 }: IconProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 26 26"
        fill="none"
    >
        <g clipPath="url(#clip0_5885_18373)">
            <path
                d="M23.3269 5.11064L18.4519 0.235638C18.376 0.160337 18.2859 0.100762 18.1869 0.0603282C18.0879 0.0198946 17.9819 -0.000601989 17.875 1.34596e-05H4.875C3.52879 1.34596e-05 2.4375 1.0913 2.4375 2.43751V23.5625C2.4375 24.9087 3.52879 26 4.875 26H21.125C22.4712 26 23.5625 24.9087 23.5625 23.5625V5.68751C23.5631 5.58058 23.5426 5.47458 23.5022 5.37559C23.4618 5.27659 23.4022 5.18656 23.3269 5.11064ZM21.9375 23.5625C21.9375 24.0113 21.5738 24.375 21.125 24.375H4.875C4.42625 24.375 4.0625 24.0113 4.0625 23.5625V2.43751C4.0625 1.98876 4.42625 1.62501 4.875 1.62501H17.0625V4.87501C17.0625 5.77247 17.79 6.50001 18.6875 6.50001H21.9375V23.5625Z"
                fill={fill}
            />
        </g>
        <defs>
            <clipPath id="clip0_5885_18373">
                <rect width={width} height={height} fill="white" />
            </clipPath>
        </defs>
    </svg>
);
